export var breadcrumbDividerStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    return {
      verticalAlign: 'middle'
    };
  }
};